import { TrayHelper, type TrayHeading } from '../layout';

interface UnlinkedTrayHeadingProps {
  heading: Readonly<TrayHeading>;
}

const UnlinkedTrayHeading = ({ heading }: UnlinkedTrayHeadingProps) => (
  <div
    style={{
      position: 'absolute',
      left: heading.x,
      top: heading.y,
      height: heading.height,
      font: TrayHelper.HEADING_FONT,
      lineHeight: `${heading.height}px`,
      color: 'var(--pf-color-soft-pearl-800)',
      whiteSpace: 'nowrap',
    }}
  >
    {heading.text}
  </div>
);

export { UnlinkedTrayHeading };
